import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Dropdowns = () => {
  return (
    <div className="tutorial-container">
      {/* ===== Embedded CSS (keeps your markup unchanged, makes dropdowns work) ===== */}
      <style>{`
/* Scoped dropdown CSS for the demo (embedded so your existing markup works) */

/* Basic positioning helpers for dropdown containers */
.tutorial-container .dropdown,
.tutorial-container .dropdown-icons,
.tutorial-container .dropdown-toggle,
.tutorial-container .multi-dropdown,
.tutorial-container .mega-dropdown,
.tutorial-container .dropdown-search,
.tutorial-container .fancy-dropdown,
.tutorial-container .mobile-dropdown {
  position: relative;
  display: inline-block;
}

/* Core dropdown panels (hidden by default) */
.tutorial-container .dropdown-content,
.tutorial-container .dropdown-icons-content,
.tutorial-container .dropdown-toggle-content,
.tutorial-container .multi-content,
.tutorial-container .multi-submenu-content,
.tutorial-container .mega-content,
.tutorial-container .dropdown-search-content,
.tutorial-container .fancy-content,
.tutorial-container .mobile-dropdown .dropdown-content,
.tutorial-container .navbar .dropdown-content {
  display: none;
  position: absolute;
  background: #fff;
  min-width: 160px;
  padding: 6px 0;
  box-shadow: 0 6px 20px rgba(2,6,23,0.08);
  border-radius: 8px;
  z-index: 999;
}

/* Default link style inside dropdowns */
.tutorial-container .dropdown-content a,
.tutorial-container .dropdown-icons-content a,
.tutorial-container .dropdown-toggle-content a,
.tutorial-container .multi-content a,
.tutorial-container .multi-submenu-content a,
.tutorial-container .mega-content a,
.tutorial-container .dropdown-search-content a,
.tutorial-container .fancy-content a,
.tutorial-container .mobile-dropdown .dropdown-content a,
.tutorial-container .navbar .dropdown-content a {
  display: block;
  padding: 8px 12px;
  color: #111827;
  text-decoration: none;
}
.tutorial-container .dropdown-content a:hover,
.tutorial-container .dropdown-icons-content a:hover,
.tutorial-container .dropdown-toggle-content a:hover,
.tutorial-container .multi-content a:hover,
.tutorial-container .multi-submenu-content a:hover,
.tutorial-container .mega-content a:hover,
.tutorial-container .dropdown-search-content a:hover,
.tutorial-container .fancy-content a:hover,
.tutorial-container .mobile-dropdown .dropdown-content a:hover,
.tutorial-container .navbar .dropdown-content a:hover {
  background: #f3f4f6;
}

/* 1) Basic hover dropdown */
.tutorial-container .dropdown:hover > .dropdown-content {
  display: block;
  top: calc(100% + 6px);
  left: 0;
}

/* 2) Hover with icons */
.tutorial-container .dropdown-icons:hover > .dropdown-icons-content {
  display: block;
  top: calc(100% + 6px);
  left: 0;
}
.tutorial-container .dropdown-icons-content a {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 12px;
}

/* 3) Click toggle (checkbox trick) — without changing your markup we use :has() on label
   (works in modern browsers). The label wraps the input in your markup, and the label is sibling to the panel.
   This avoids altering your HTML structure. */
.tutorial-container .dropdown-toggle label input { display: none; }
.tutorial-container .dropdown-toggle label:has(input:checked) + .dropdown-toggle-content {
  display: block;
  top: calc(100% + 6px);
  left: 0;
}

/* 4) Animated dropdown — use transform + opacity for smooth entry (we keep it display:block but invisible) */
.tutorial-container .dropdown-animate .dropdown-animate-content {
  display: block; /* present in flow but invisible until hovered */
  opacity: 0;
  transform: translateY(8px);
  transition: transform .22s cubic-bezier(.2,.9,.2,1), opacity .22s ease;
  pointer-events: none;
  top: calc(100% + 6px);
  left: 0;
}
.tutorial-container .dropdown-animate:hover > .dropdown-animate-content {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

/* 5) Multi-level / nested dropdowns */
.tutorial-container .multi-dropdown:hover > .multi-content {
  display: block;
  top: calc(100% + 6px);
  left: 0;
}
.tutorial-container .multi-submenu { position: relative; }
.tutorial-container .multi-submenu .multi-submenu-content {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  min-width: 140px;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(2,6,23,0.08);
}
.tutorial-container .multi-submenu:hover > .multi-submenu-content {
  display: block;
}

/* 6) Full-width mega menu */
.tutorial-container .mega-content {
  display: none;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  padding: 18px;
  background: #f9fafb;
  box-shadow: 0 12px 30px rgba(2,6,23,0.12);
}
.tutorial-container .mega-dropdown:hover > .mega-content {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

/* 7) Dropdown with search */
.tutorial-container .dropdown-search:hover > .dropdown-search-content {
  display: block;
  top: calc(100% + 6px);
  left: 0;
}
.tutorial-container .dropdown-search-content input {
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 6px;
  border: 1px solid #e6e6e6;
}

/* 8) Fancy button trigger */
.tutorial-container .fancy-dropdown button {
  background: linear-gradient(90deg,#3b82f6,#06b6d4);
  color: #fff;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(59,130,246,0.12);
}
.tutorial-container .fancy-dropdown:hover > .fancy-content {
  display: block;
  top: calc(100% + 6px);
  right: 0;
}

/* 9) Navbar dropdown */
.tutorial-container .navbar {
  display: flex;
  gap: 8px;
  background: #111827;
  padding: 8px 12px;
  border-radius: 8px;
  align-items: center;
}
.tutorial-container .navbar a {
  color: white;
  text-decoration: none;
  padding: 8px 10px;
  display: inline-block;
}
.tutorial-container .navbar .dropdown:hover > .dropdown-content {
  display: block;
  top: calc(100% + 6px);
  left: 0;
}
/* Keep dropdown items readable (white nav -> white panel -> dark text) */
.tutorial-container .navbar .dropdown-content a {
  color: #111827;
}

/* 10) Responsive mobile dropdown — keep it hover/click-friendly (simple) */
.tutorial-container .mobile-dropdown:hover > .dropdown-content {
  display: block;
  top: calc(100% + 6px);
  left: 0;
}
/* show mobile toggle style (if you later add checkbox) */
@media (max-width: 600px) {
  .tutorial-container .mobile-dropdown { display: block; }
}

/* Small demo helpers */
.tutorial-container button { background: #fff; border: 1px solid #e6e6e6; padding: 8px 12px; border-radius: 6px; cursor: pointer; }
.tutorial-container .tutorial-section { margin-bottom: 1.6rem; }
`}</style>

      <h1 className="tutorial-title">📑 10 Different CSS Dropdowns</h1>

      <p className="tutorial-intro">
        Dropdown menus are widely used in navigation bars, forms, and UI
        elements. Here are <b>10 different dropdown styles</b> ranging from
        basic hover menus to advanced mega menus with search and responsive
        design.
      </p>

      {/* 📌 List of Types */}
      <div
        style={{
          background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#1e3a8a", marginBottom: "0.5rem" }}>
          📘 Types of Dropdowns
        </h2>
        <ul style={{ lineHeight: "1.8", marginLeft: "1.2rem" }}>
          <li>1️⃣ Basic Hover Dropdown</li>
          <li>2️⃣ Hover with Icons</li>
          <li>3️⃣ Click Toggle Dropdown</li>
          <li>4️⃣ Dropdown with Animation</li>
          <li>5️⃣ Multi-Level (Nested) Dropdown</li>
          <li>6️⃣ Full-Width Mega Menu</li>
          <li>7️⃣ Dropdown with Search Bar</li>
          <li>8️⃣ Styled/Fancy Button Dropdown</li>
          <li>9️⃣ Dropdown inside Navbar</li>
          <li>🔟 Responsive Mobile Dropdown</li>
        </ul>
      </div>

      {/* Example 1 - Basic Hover Dropdown */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Basic Hover Dropdown</h2>
        <CodeCopyBlock
          code={`.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background: #f9fafb;
  min-width: 160px;
  box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content a {
  display: block;
  padding: 10px 14px;
  text-decoration: none;
  color: #111827;
}

.dropdown-content a:hover {
  background: #e5e7eb;
}`}
        />
        <div className="dropdown" style={{ margin: "20px" }}>
          <button
            style={{
              padding: "10px 16px",
              backgroundColor: "#e7e5e5ff",
              border: " 1px solid red",
            }}
          >
            Menu ⬇
          </button>
          <div className="dropdown-content">
            <a href="#">Link 1</a>
            <a href="#">Link 2</a>
            <a href="#">Link 3</a>
          </div>
        </div>
      </div>

      {/* Example 2 - Hover with Icons */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Hover with Icons</h2>
        <CodeCopyBlock
          code={`.dropdown-icons {
  position: relative;
  display: inline-block;
}

.dropdown-icons-content {
  display: none;
  position: absolute;
  background: #fff;
  min-width: 180px;
  box-shadow: 0px 4px 6px rgba(0,0,0,0.15);
}

.dropdown-icons:hover .dropdown-icons-content {
  display: block;
}

.dropdown-icons-content a {
  padding: 10px;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: #111827;
}

.dropdown-icons-content a:hover {
  background: #f3f4f6;
}`}
        />
        <div className="dropdown-icons" style={{ margin: "20px" }}>
          <button
            style={{
              padding: "10px 16px",
              backgroundColor: "#e7e5e5ff",
              border: " 1px solid red",
            }}
          >
            Options ⬇
          </button>
          <div className="dropdown-icons-content">
            <a href="#">⭐ Favorites</a>
            <a href="#">⚙ Settings</a>
            <a href="#">🔒 Logout</a>
          </div>
        </div>
      </div>

      {/* Example 3 - Click Toggle Dropdown */}
      <div className="tutorial-section">
        <h2 className="section-title">
          3️⃣ Click Toggle Dropdown (Checkbox Trick)
        </h2>
        <CodeCopyBlock
          code={`.dropdown-toggle {
  position: relative;
  display: inline-block;
}

.dropdown-toggle input {
  display: none;
}

.dropdown-toggle-content {
  display: none;
  position: absolute;
  background: #fff;
  box-shadow: 0px 4px 6px rgba(0,0,0,0.15);
}

.dropdown-toggle input:checked + .dropdown-toggle-content {
  display: block;
}`}
        />
        <div className="dropdown-toggle" style={{ margin: "20px" }}>
          <label style={{ cursor: "pointer", padding: "10px 16px" }}>
            <input type="checkbox" /> Menu ⬇
          </label>
          <div className="dropdown-toggle-content">
            <a href="#">Profile</a>
            <a href="#">Dashboard</a>
            <a href="#">Logout</a>
          </div>
        </div>
      </div>

      {/* Example 4 - Dropdown with Animation */}
      <div className="tutorial-section">
        <h2 className="section-title">4️⃣ Dropdown with Animation</h2>
        <CodeCopyBlock
          code={`.dropdown-animate {
  position: relative;
  display: inline-block;
}

.dropdown-animate-content {
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
  position: absolute;
  background: white;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.dropdown-animate:hover .dropdown-animate-content {
  opacity: 1;
  transform: translateY(0);
}`}
        />
        <div className="dropdown-animate" style={{ margin: "20px" }}>
          <button
            style={{
              padding: "10px 16px",
              backgroundColor: "#e7e5e5ff",
              border: " 1px solid red",
            }}
          >
            Animated ⬇
          </button>
          <div className="dropdown-animate-content">
            <a href="#">Docs</a>
            <a href="#">API</a>
            <a href="#">Support</a>
          </div>
        </div>
      </div>

      {/* Example 5 - Multi-Level Dropdown */}
      <div className="tutorial-section">
        <h2 className="section-title">5️⃣ Multi-Level (Nested) Dropdown</h2>
        <CodeCopyBlock
          code={`.multi-dropdown {
  position: relative;
  display: inline-block;
}

.multi-content {
  display: none;
  position: absolute;
  background: #fff;
  min-width: 160px;
}

.multi-dropdown:hover .multi-content {
  display: block;
}

.multi-submenu {
  position: relative;
}

.multi-submenu-content {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
}

.multi-submenu:hover .multi-submenu-content {
  display: block;
}`}
        />
        <div className="multi-dropdown" style={{ margin: "20px" }}>
          <button
            style={{
              padding: "10px 16px",
              backgroundColor: "#e7e5e5ff",
              border: " 1px solid red",
            }}
          >
            Products ⬇
          </button>
          <div className="multi-content">
            <a href="#">Electronics</a>
            <div className="multi-submenu">
              <a href="#">Clothing ⮕</a>
              <div className="multi-submenu-content">
                <a href="#">Men</a>
                <a href="#">Women</a>
              </div>
            </div>
            <a href="#">Books</a>
          </div>
        </div>
      </div>

      {/* Example 6 - Full-Width Mega Menu */}
      <div className="tutorial-section">
        <h2 className="section-title">6️⃣ Full-Width Mega Menu</h2>
        <CodeCopyBlock
          code={`.mega-dropdown {
  position: relative;
  display: inline-block;
}

.mega-content {
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  background: #f9fafb;
  padding: 20px;
}

.mega-dropdown:hover .mega-content {
  display: flex;
  justify-content: space-around;
}`}
        />
        <div
          className="mega-dropdown"
          style={{ margin: "20px", width: "100%" }}
        >
          <button
            style={{
              padding: "10px 16px",
              backgroundColor: "#e7e5e5ff",
              border: " 1px solid red",
            }}
          >
            Mega Menu ⬇
          </button>
          <div className="mega-content">
            <div>
              <h4>Category 1</h4>
              <a href="#">Link 1</a>
              <a href="#">Link 2</a>
            </div>
            <div>
              <h4>Category 2</h4>
              <a href="#">Link 3</a>
              <a href="#">Link 4</a>
            </div>
            <div>
              <h4>Category 3</h4>
              <a href="#">Link 5</a>
              <a href="#">Link 6</a>
            </div>
          </div>
        </div>
      </div>

      {/* Example 7 - Dropdown with Search */}
      <div className="tutorial-section">
        <h2 className="section-title">7️⃣ Dropdown with Search Bar</h2>
        <CodeCopyBlock
          code={`.dropdown-search {
  position: relative;
  display: inline-block;
}

.dropdown-search-content {
  display: none;
  position: absolute;
  background: white;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.dropdown-search:hover .dropdown-search-content {
  display: block;
}`}
        />
        <div className="dropdown-search" style={{ margin: "20px" }}>
          <button
            style={{
              padding: "10px 16px",
              backgroundColor: "#e7e5e5ff",
              border: " 1px solid red",
            }}
          >
            Search Menu ⬇
          </button>
          <div className="dropdown-search-content">
            <input
              type="text"
              placeholder="Search..."
              style={{
                width: "100%",
                padding: "8px",
                marginBottom: "8px",
                border: "1px solid #020202ff",
              }}
            />
            <a href="#">Apple</a>
            <a href="#">Banana</a>
            <a href="#">Cherry</a>
          </div>
        </div>
      </div>

      {/* Example 8 - Fancy Button Dropdown */}
      <div className="tutorial-section">
        <h2 className="section-title">8️⃣ Styled Fancy Button Dropdown</h2>
        <CodeCopyBlock
          code={`.fancy-dropdown button {
  background: linear-gradient(90deg, #3b82f6, #06b6d4);
  border: none;
  color: white;
  padding: 10px 18px;
  border-radius: 6px;
}

.fancy-content {
  display: none;
  position: absolute;
  background: white;
  min-width: 160px;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
}

.fancy-dropdown:hover .fancy-content {
  display: block;
}`}
        />
        <div className="fancy-dropdown" style={{ margin: "20px" }}>
          <button>Fancy Menu ⬇</button>
          <div className="fancy-content">
            <a href="#">Download</a>
            <a href="#">Upload</a>
            <a href="#">Share</a>
          </div>
        </div>
      </div>

      {/* Example 9 - Dropdown inside Navbar */}
      <div className="tutorial-section">
        <h2 className="section-title">9️⃣ Dropdown inside Navbar</h2>
        <CodeCopyBlock
          code={`.navbar {
  display: flex;
  background: #111827;
  padding: 10px;
}

.navbar a {
  color: white;
  padding: 10px;
  text-decoration: none;
}

.navbar .dropdown-content {
  position: absolute;
  background: white;
}`}
        />
        <div className="navbar2">
          <a href="#">Home</a>
          <div className="dropdown">
            <a href="#">Services ⬇</a>
            <div className="dropdown-content">
              <a href="#">Web Design</a>
              <a href="#">Hosting</a>
              <a href="#">SEO</a>
            </div>
          </div>
        </div>
      </div>

      {/* Example 10 - Responsive Mobile Dropdown */}
      <div className="tutorial-section">
        <h2 className="section-title">🔟 Responsive Mobile Dropdown</h2>
        <CodeCopyBlock
          code={`.mobile-dropdown {
  display: none;
}

@media (max-width: 600px) {
  .mobile-dropdown {
    display: block;
  }
}`}
        />
        <div className="mobile-dropdown">
          <button style={{ padding: "10px 16px" }}>☰ Menu</button>
          <div className="dropdown-content">
            <a href="#">Dashboard</a>
            <a href="#">Profile</a>
            <a href="#">Logout</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CSS_Dropdowns;
